import React, { Component } from "react"
import { Button, Modal } from "react-bootstrap"
import TestSteps from "./EventDetails/TestSteps"
import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import { Subscription } from "rxjs"
import { toast } from "react-toastify"
import { CurrentServiceDetailsForCompare, ResolveAlert } from "../../api/OrderResults/CurrentServiceDetails"
import ServiceDetails from "../../api/OrderResults/OrderResultModel/ServiceDetails"
import { ImplementationTypeGovt, StorageKey } from "../../config/Constants"
import TestEventUpdateData from "../../api/OrderResults/OrderResultModel/TestEventUpdateData"
import DrugTestCompare from "./EventDetails/DrugTestCompare"

interface EventDetailsCompareProps {
  details: OrderResultRecord
  onHide: () => void
  onRefreshGrid?: () => void
}

interface EventDetailsCompareState {
  dataNew?: ServiceDetails
  dataOld?: ServiceDetails
  loadingNew: boolean
  loadingOld: boolean
}

export default class EventDetailsCompare extends Component<EventDetailsCompareProps, EventDetailsCompareState> {
  subscriptionNew?: Subscription
  subscriptionOld?: Subscription
  updateSubscription?: Subscription
  state: EventDetailsCompareState = { dataNew: undefined, dataOld: undefined, loadingNew: false, loadingOld: false}
  isOnTrack: boolean = sessionStorage.getItem(StorageKey.ImplementationType) === ImplementationTypeGovt

  componentDidMount() {
    this.setState({ loadingNew: true, loadingOld: true, dataNew: undefined, dataOld: undefined })
    const details = this.props.details
    this.subscriptionNew = CurrentServiceDetailsForCompare({ TestDetailClinicalID: undefined, TestDetailID: details.TestDetailID }).subscribe(
      (data: ServiceDetails) => {
        this.setState({ dataNew: data, loadingNew: false })
        this.subscriptionOld = CurrentServiceDetailsForCompare({ TestDetailClinicalID: undefined, TestDetailID: details.MergeFrom }).subscribe(
          (data: ServiceDetails) => this.setState({ dataOld: data, loadingOld: false }),
          (error: string) => {
            this.setState({ loadingOld: false })
            toast.error(error)
          }
        )
      },
      (error: string) => {
        this.setState({ loadingNew: false })
        toast.error(error)
      }
    )
  }

  handleSave = () => {
    this.updateSubscription = ResolveAlert({TestEventAlertID: this.props.details.TestEventAlertID}).subscribe(
      (data: string) => {
        toast.success(data)
        this.props.onHide();
        this.props.onRefreshGrid && this.props.onRefreshGrid();
      }),
      (error: string) => {
        toast.error(error)
        this.props.onHide();
      }
  }
  handleCancel = () => {
    this.props.onHide();
    this.props.onRefreshGrid && this.props.onRefreshGrid();
  }
  componentWillUnmount() {
    this.subscriptionNew && this.subscriptionNew.unsubscribe()
    this.subscriptionOld && this.subscriptionOld.unsubscribe()
    this.updateSubscription && this.updateSubscription.unsubscribe()
  }
  hasChanges() {
    const currentRowInfo = this.props.details
    const currentServiceInfoNew = this.state.dataNew
    if (!currentServiceInfoNew) {
      return false
    }
    const currentServiceInfoOld = this.state.dataOld
    if (!currentServiceInfoOld) {
      return false
    }
    const panelInfoNew = currentServiceInfoNew.Panel
    const panelInfoOld = currentServiceInfoOld.Panel
    const EventDataNew = currentServiceInfoNew.EventData
    const EventDataOld = currentServiceInfoOld.EventData

    if (currentServiceInfoNew.CCFName !== currentServiceInfoOld.CCFName) {
      return true
    }
    if (EventDataNew?.RegulatoryModeName !== EventDataOld?.RegulatoryModeName) {
      return true
    }
    if (EventDataNew?.EmployeeCategoryName !== EventDataOld?.EmployeeCategoryName) {
      return true
    }
    if (EventDataNew?.CompanyName !== EventDataOld?.CompanyName) {
      return true
    }
    if (EventDataNew?.LocationName !== EventDataOld?.LocationName) {
      return true
    }
    if (currentServiceInfoNew.LabAccountNumber !== currentServiceInfoOld.LabAccountNumber) {
      return true
    }
    if (currentServiceInfoNew.TestReasonDescription !== currentServiceInfoOld.TestReasonDescription) {
      return true
    }
    if (currentServiceInfoNew.SampleID !== currentServiceInfoOld.SampleID) {
      return true
    }
    if ((currentServiceInfoNew.TestTypeDescription !== currentServiceInfoOld.TestTypeDescription) || (currentServiceInfoNew.SampleID !== currentServiceInfoOld.SampleID)) {
      return true
    }
    if ((currentServiceInfoNew.TestTypeDescription !== currentServiceInfoOld.TestTypeDescription) || (currentServiceInfoNew.SampleID !== currentServiceInfoOld.SampleID)) {
      return true
    }
    if (currentServiceInfoNew.SampleTypeDescription !== currentServiceInfoOld.SampleTypeDescription) {
      return true
    }
    if (panelInfoNew?.Description !== panelInfoOld?.Description) {
      return true
    }
    if (currentServiceInfoNew.DOT !== currentServiceInfoOld.DOT) {
      return true
    }
    if (currentServiceInfoNew.TestReleaseStatusDescription !== currentServiceInfoOld.TestReleaseStatusDescription) {
      return true
    }
    return false
  }
  render() {
    const currentRowInfo = this.props.details
    const currentServiceInfoNew = this.state.dataNew
    const currentServiceInfoOld = this.state.dataOld
    const hasChanges = this.hasChanges()
    return currentRowInfo && currentServiceInfoNew && currentServiceInfoOld ? (
      <Modal show onHide={this.props.onHide} size="xl" dialogClassName="dark">
        <Modal.Header closeButton>
          <Modal.Title>EVENT DETAILS COMPARE</Modal.Title>
        </Modal.Header>
        <Modal.Body className="event-details">
          <DrugTestCompare currentRowInfo={currentRowInfo} currentServiceInfoNew={currentServiceInfoNew} currentServiceInfoOld={currentServiceInfoOld} isOnTrack={this.isOnTrack} hasChanges={hasChanges} />
        </Modal.Body>
        {<Modal.Footer>
          
          {hasChanges && <Button variant="primary" onClick={this.handleSave} className="fixed-w5 ml-2">Accept</Button>}
          {hasChanges && <Button variant="secondary" onClick={this.handleCancel} className="fixed-w5 ml-2">Postpone</Button>}
          {!hasChanges && <Button variant="secondary" onClick={this.handleCancel} className="fixed-w5 ml-2">Close</Button>}
        </Modal.Footer>}
      </Modal>
    ) : null
  }
}
